export default "__VITE_ASSET__$Ufzd5eO__"